import {Permission} from "../../Permission";
import {P415FileUpload} from "../P415FileUpload";
import {P415Client, P415FileApi, P415FileType} from "../../client/P415Client";
import {MeterApi, MeterClient} from "../../client/MeterClient";
import {useEntitlements} from "../../EntitlementProvider";
import React, {useEffect, useState} from "react";
import {Result} from "../../client/Result";
import {BuildingClient} from "../../client/BuildingClient";
import {P415FilesSentToEdf} from "../P415FilesSentToEdf";

export interface P415PageProps {
    p415Client: P415Client
    meterClient: MeterClient
    buildingClient: BuildingClient
    disableVirtualizationForTesting?: boolean
}

export function P415Page({p415Client, meterClient, buildingClient, disableVirtualizationForTesting}: P415PageProps) {
    const entitlement = useEntitlements()
    const allBuildingsOption = {id: -1, name: 'All Sites'}

    const [meters, setMeters] = useState<MeterApi[]>([])
    const [buildings, setBuildings] = useState<{ id: number, name: string }[]>([allBuildingsOption])
    const [selectedBuilding, setSelectedBuilding] = useState<{ id: number, name: string }>(allBuildingsOption)
    const [p415Files, setP415Files] = useState<P415FileApi[]>([])

    const selectedBuildingOrAllBuildings = selectedBuilding.id == allBuildingsOption.id ? undefined : selectedBuilding
    const refreshFiles = () => p415Client.listFiles(selectedBuildingOrAllBuildings).then(maybeFiles => maybeFiles.map(setP415Files))

    const onFileUpload = async (mpan: string, fileType: P415FileType, file: File): Promise<Result<null>> => {
        return p415Client.uploadFile(mpan, fileType, file).then(result => {
            refreshFiles()
            return result
        })
    }

    useEffect(() => {
        meterClient.retrieveMeters().then(ms => setMeters(ms))
    }, [meterClient])

    useEffect(() => void refreshFiles(), [p415Client, selectedBuilding])

    useEffect(() => {
        buildingClient.retrieveBuildingsWithMeterMpans().then(bs => setBuildings([allBuildingsOption, ...bs.map(b => ({
            id: b.id,
            name: b.name
        }))]))
    }, [buildingClient])

    return (
        <>
            <div className="section-container px-4" data-testid="p415-section">
                    {entitlement.has(Permission.WRITE_UPLOAD_TO_EDF) && (
                        <>
                        <div className="row px-3">
                            <P415FileUpload
                                className="col-12 px-0 mb-3"
                                mpans={meters.map(m => m.mpan)}
                                onFileUpload={onFileUpload}
                            />
                        </div>
                        <div className="row px-3">
                            <P415FilesSentToEdf
                                className="col-12 px-0 mb-3"
                                p415Files={p415Files} buildings={buildings}
                                selectedBuilding={selectedBuilding} setSelectedBuilding={setSelectedBuilding}
                                p415Client={p415Client}
                                disableVirtualizationForTesting={disableVirtualizationForTesting}/>
                        </div>
                        </>
                    )}
            </div>
        </>
    )
}
